import { get } from './index'

/**
 * 活动相关的API服务
 * 按照API指南规范：使用基础HTTP方法，标准命名规范
 */

/**
 * 获取活动列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页数量
 * @param {string} params.category - 分类
 * @param {string} params.keyword - 关键词
 * @returns {Promise} 活动列表响应
 */
export const getActivities = (params = {}) => {
  return get('/activity/list', params)
}

/**
 * 获取活动详情
 * @param {string} id - 活动ID
 * @returns {Promise} 活动详情响应
 */
export const getActivityDetail = (id, locale = '') => {
  const localeParam = locale ? `&locale=${locale}` : ''
  return get(`/activity/getActivityById?activityId=${id}${localeParam}`)
}

/**
 * 获取活动分类列表
 * @returns {Promise} 分类列表响应
 */
// export const getActivityCategories = () => {
//   return get('/activities/categories')
// }

/**
 * 搜索活动
 * @param {Object} params - 搜索参数
 * @param {string} params.keyword - 搜索关键词
 * @param {string} params.category - 分类筛选
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise} API响应
 */
export const searchActivities = (params = {}) => {
  return get('/activities/search', params)
}

export default {
  getActivities,
  getActivityDetail,
  // getActivityCategories
}
